if ( typeof ProductImageZoom !== 'function' ) {
	class ProductImageZoom extends HTMLElement {

		constructor(){

			super();

			if ( ! document.getElementById('zoom') ) {
				this.zoom = document.createElement('div');
				this.zoom.id = 'zoom';

				/*
				Original code commented:
				This original structure only supported image zoom.
				We commented it because we now need:
				1. Images
				2. Videos
				3. 3D models
				4. Previous / Next buttons
				5. Bottom thumbnails
				6. Popup and thumbnail background color #E8ECF2
				7. Swipe gestures on mobile
				8. Mouse drag swipe on desktop
				9. Keyboard navigation
				10. Active thumbnail auto-scroll centered
				11. Shopify product media order
				12. Subtle zoom-in animation
				13. Preload next/previous media
				14. Visible zoom-out button for all media types

				this.zoom.innerHTML = `
					<img />
					<span class="zoom__exit">${KROWN.settings.symbols.zoom_out}</span>
					<span class="zoom__loader">${KROWN.settings.symbols.zoom_loader}</span>
					<div class="zoom__overlay"></div>
				`;
				*/

				/*
				Updated code:
				Keeps a main image element for images.
				Adds a media stage for videos and 3D models.
				Adds Previous / Next buttons and thumbnail strip.
				Adds inline styling so no CSS file editing is required.
				*/
				this.zoom.style.background = '#E8ECF2';

				this.zoom.innerHTML = `
					<img class="zoom__main-image" style="
						transition: transform 0.28s ease, opacity 0.28s ease;
						transform: scale(0.96);
						opacity: 0;
					" />

					<div class="zoom__media-stage" style="
						position: fixed;
						left: 50%;
						top: 50%;
						transform: translate(-50%, -50%) scale(0.96);
						opacity: 0;
						transition: transform 0.28s ease, opacity 0.28s ease;
						z-index: 999998;
						display: none;
						align-items: center;
						justify-content: center;
						background: #E8ECF2;
					"></div>

					<button class="zoom__prev" type="button" style="
						position: fixed;
						left: 16px;
						top: 50%;
						transform: translateY(-50%);
						z-index: 999999;
						width: 44px;
						height: 44px;
						border-radius: 50%;
						border: none;
						background: rgba(0,0,0,0.45);
						color: #fff;
						font-size: 34px;
						line-height: 40px;
						cursor: pointer;
					">‹</button>

					<button class="zoom__next" type="button" style="
						position: fixed;
						right: 16px;
						top: 50%;
						transform: translateY(-50%);
						z-index: 999999;
						width: 44px;
						height: 44px;
						border-radius: 50%;
						border: none;
						background: rgba(0,0,0,0.45);
						color: #fff;
						font-size: 34px;
						line-height: 40px;
						cursor: pointer;
					">›</button>

					<div class="zoom__thumbs" style="
						position: fixed;
						left: 50%;
						bottom: 18px;
						transform: translateX(-50%);
						z-index: 999999;
						display: flex;
						gap: 8px;
						max-width: calc(100vw - 32px);
						overflow-x: auto;
						padding: 8px;
						background: #E8ECF2;
						border-radius: 14px;
						scroll-behavior: smooth;
					"></div>

					<span class="zoom__exit" style="
						position: fixed;
						right: 18px;
						top: 18px;
						z-index: 1000000;
						cursor: pointer;
						background: rgba(0,0,0,0.45);
						color: #fff;
						border-radius: 50%;
						width: 44px;
						height: 44px;
						display: flex;
						align-items: center;
						justify-content: center;
					">${KROWN.settings.symbols.zoom_out}</span>

					<span class="zoom__loader">${KROWN.settings.symbols.zoom_loader}</span>
					<div class="zoom__overlay" style="background: #E8ECF2;"></div>
				`;

				document.body.append(this.zoom);

				this.zoom.querySelector('.zoom__exit').addEventListener('click', this._productZoomUnmount.bind(this));

				this.zoom.querySelector('.zoom__prev').addEventListener('click', (e) => {
					e.stopPropagation();
					if ( this.zoom.activeZoomInstance ) {
						this.zoom.activeZoomInstance._changeZoomMedia(-1);
					}
				});

				this.zoom.querySelector('.zoom__next').addEventListener('click', (e) => {
					e.stopPropagation();
					if ( this.zoom.activeZoomInstance ) {
						this.zoom.activeZoomInstance._changeZoomMedia(1);
					}
				});

			} else {
				this.zoom = document.getElementById('zoom');
				this.zoom.style.background = '#E8ECF2';
			}

			this.onMouseMoveHandlerBinded = this.onMouseMoveHandler.bind(this);
			this.onResizeHandlerBinded = this.onResizeHandler.bind(this);
			this.onKeyDownHandlerBinded = this.onKeyDownHandler.bind(this);
			this.onTouchStartHandlerBinded = this.onTouchStartHandler.bind(this);
			this.onTouchEndHandlerBinded = this.onTouchEndHandler.bind(this);
			this.onMouseDownHandlerBinded = this.onMouseDownHandler.bind(this);
			this.onMouseUpHandlerBinded = this.onMouseUpHandler.bind(this);

			this.touchStartX = 0;
			this.touchStartY = 0;
			this.mouseStartX = 0;
			this.mouseStartY = 0;
			this.isMouseDown = false;

			/*
			Original code commented:
			This only opened the clicked image.
			We commented it because we now need to collect all product media and navigate between them.

			this.addEventListener('click', (e)=>{
				this.zoom.classList.add('opened');
				this.image = this.zoom.querySelector('img');
				this.image.src = this.getAttribute('data-image');
				if ( this.image.naturalWidth > 0 ) {
					this._productZoomMount();
				} else {
					this.image.addEventListener('load', this._productZoomMount.bind(this));
				}
			});
			*/

			/*
			Updated code:
			Opens the zoom popup.
			Collects available images, videos, 3D models, and Shopify deferred media.
			Builds thumbnails.
			Adds swipe gestures, desktop mouse drag navigation, and keyboard navigation.
			Loads the clicked media item.
			*/
			this.addEventListener('click', (e)=>{

				this.zoom.activeZoomInstance = this;

				this.zoom.style.background = '#E8ECF2';
				this.zoom.classList.add('opened');

				this.image = this.zoom.querySelector('.zoom__main-image');
				this.stage = this.zoom.querySelector('.zoom__media-stage');

				this.zoomMediaItems = this._collectProductMedia();
				this.currentZoomIndex = this._findCurrentMediaIndex();

				this._buildZoomThumbnails();
				this._loadZoomMedia(this.currentZoomIndex);

				document.addEventListener('keydown', this.onKeyDownHandlerBinded);
				this.zoom.addEventListener('touchstart', this.onTouchStartHandlerBinded, { passive: true });
				this.zoom.addEventListener('touchend', this.onTouchEndHandlerBinded, { passive: true });

				/*
				Updated code:
				Adds desktop mouse drag navigation.
				Click and drag left = next media.
				Click and drag right = previous media.
				*/
				this.zoom.addEventListener('mousedown', this.onMouseDownHandlerBinded);
				this.zoom.addEventListener('mouseup', this.onMouseUpHandlerBinded);

			});

		}

		/*
		Original code commented:
		This made the image follow the cursor.
		We commented it because the media should stay stable inside the popup.

		onMouseMoveHandler(e){
			window.clientX = e.clientX;
			window.clientY = e.clientY;
			const x = e.clientX * ( window.innerWidth - this.image.offsetWidth ) / window.innerWidth;
			const y = e.clientY * ( window.innerHeight - this.image.offsetHeight ) / window.innerHeight;
			this.image.style.left = x + 'px';
			this.image.style.top = y + 'px';
		}
		*/

		/*
		Updated code:
		Disables cursor-follow movement.
		*/
		onMouseMoveHandler(e){
			// Cursor movement disabled intentionally
		}

		/*
		Updated code:
		Keyboard navigation.
		ArrowRight = next media.
		ArrowLeft = previous media.
		Escape = close popup.
		*/
		onKeyDownHandler(e){

			if ( ! this.zoom.classList.contains('opened') ) return;

			if ( e.key === 'ArrowRight' ) {
				this._changeZoomMedia(1);
			}

			if ( e.key === 'ArrowLeft' ) {
				this._changeZoomMedia(-1);
			}

			if ( e.key === 'Escape' ) {
				this._productZoomUnmount();
			}

		}

		/*
		Updated code:
		Stores touch start position for mobile swipe gestures.
		*/
		onTouchStartHandler(e){

			if ( ! e.changedTouches || ! e.changedTouches.length ) return;

			this.touchStartX = e.changedTouches[0].screenX;
			this.touchStartY = e.changedTouches[0].screenY;

		}

		/*
		Updated code:
		Mobile swipe gestures.
		Swipe left = next media.
		Swipe right = previous media.
		Vertical swipes are ignored.
		*/
		onTouchEndHandler(e){

			if ( ! e.changedTouches || ! e.changedTouches.length ) return;

			const touchEndX = e.changedTouches[0].screenX;
			const touchEndY = e.changedTouches[0].screenY;

			const diffX = touchEndX - this.touchStartX;
			const diffY = touchEndY - this.touchStartY;

			if ( Math.abs(diffX) < 50 ) return;
			if ( Math.abs(diffY) > Math.abs(diffX) ) return;

			if ( diffX < 0 ) {
				this._changeZoomMedia(1);
			} else {
				this._changeZoomMedia(-1);
			}

		}

		/*
		Updated code:
		Stores mouse start position for desktop drag navigation.
		*/
		onMouseDownHandler(e){

			if ( e.target.closest('.zoom__thumb') || e.target.closest('.zoom__prev') || e.target.closest('.zoom__next') || e.target.closest('.zoom__exit') ) return;

			this.isMouseDown = true;
			this.mouseStartX = e.screenX;
			this.mouseStartY = e.screenY;

		}

		/*
		Updated code:
		Desktop mouse drag navigation.
		Drag left = next media.
		Drag right = previous media.
		Vertical drags are ignored.
		*/
		onMouseUpHandler(e){

			if ( ! this.isMouseDown ) return;

			this.isMouseDown = false;

			const mouseEndX = e.screenX;
			const mouseEndY = e.screenY;

			const diffX = mouseEndX - this.mouseStartX;
			const diffY = mouseEndY - this.mouseStartY;

			if ( Math.abs(diffX) < 70 ) return;
			if ( Math.abs(diffY) > Math.abs(diffX) ) return;

			if ( diffX < 0 ) {
				this._changeZoomMedia(1);
			} else {
				this._changeZoomMedia(-1);
			}

		}

		/*
		Original code commented:
		This made images oversized and required scrolling.
		We commented it because the media should fit inside the viewport.

		onResizeHandler(){

			const rf = window.innerWidth > 768 ? 1 : 2;

			if ( this.image.classList.contains('portrait') ) {
				this.image.style.width = ( window.innerWidth*rf ) + 'px';
				this.image.style.height = ( window.innerWidth*rf / this.image.dataset.ratio ) + 'px';
			} else {

				this.image.style.height = ( window.innerHeight*rf ) + 'px';
				this.image.style.width = ( window.innerHeight*rf * this.image.dataset.ratio ) + 'px';

				if ( this.image.offsetWidth < window.innerWidth ) {
					this.image.style.width = ( window.innerWidth*rf ) + 'px';
					this.image.style.height = ( window.innerWidth*rf / this.image.dataset.ratio ) + 'px';
				}

			}

			const x = window.clientX * ( window.innerWidth - this.image.offsetWidth ) / window.innerWidth;
			const y = window.clientY * ( window.innerHeight - this.image.offsetHeight ) / window.innerHeight;

		}
		*/

		/*
		Updated code:
		Uses your adjusted sizing logic.
		Keeps zoom centered using flex.
		Fits image and media using real screen width.
		*/
		onResizeHandler(){

			const bottomSpaceForThumbs = 120;
			const maxWidth = window.innerWidth - 30;
			const maxHeight = window.innerHeight - bottomSpaceForThumbs;

			if ( this.image ) {
				
				this.zoom.style.display = 'flex';
				this.zoom.style.alignItems = 'center';
				this.zoom.style.justifyContent = 'center';
				this.zoom.style.overflow = 'hidden';

				this.image.style.position = 'relative';
				this.image.style.left = 'auto';
				this.image.style.top = 'auto';
				this.image.style.width = 'auto';
				this.image.style.height = 'auto';
				
				const padding = 20;
				this.image.style.maxWidth = (window.innerWidth - padding) + 'px';
				this.image.style.maxHeight = (window.innerHeight - padding) + 'px';
				
				this.image.style.objectFit = 'contain';

			}

			if ( this.stage ) {
				
				const padding = 20;
				
				this.stage.style.width = (window.innerWidth - padding) + 'px';
				this.stage.style.height = (window.innerWidth - padding) + 'px';

				this.stage.style.maxWidth = (window.innerWidth - padding) + 'px';
				this.stage.style.maxHeight = (window.innerHeight - padding) + 'px';

				if ( this.image ) {
					this.image.style.maxWidth = (window.innerWidth - padding) + 'px';
					this.image.style.maxHeight = (window.innerHeight - padding) + 'px';
				}

				this.stage.style.background = '#E8ECF2';
			}

		}

		_getVideoSrc(video) {

			if ( ! video ) return '';

			const source = video.querySelector('source');

			return (
				video.currentSrc ||
				video.src ||
				video.getAttribute('src') ||
				video.dataset.src ||
				video.getAttribute('data-src') ||
				(source ? source.src : '') ||
				(source ? source.getAttribute('src') : '') ||
				(source ? source.dataset.src : '') ||
				(source ? source.getAttribute('data-src') : '') ||
				''
			);

		}

		_getVideoPoster(video) {

			if ( ! video ) return '';

			return (
				video.getAttribute('poster') ||
				video.dataset.poster ||
				video.getAttribute('data-poster') ||
				''
			);

		}

		_collectProductMedia() {

			const media = [];
			const usedSources = new Set();

			const addMedia = (item) => {
				if ( ! item || ! item.src || usedSources.has(item.src) ) return;
				usedSources.add(item.src);
				media.push(item);
			};

			const collectFromScope = (scope) => {

				if ( ! scope ) return;

				if ( scope.matches && scope.matches('product-image-zoom[data-image]') ) {
					const src = scope.getAttribute('data-image');
					addMedia({
						type: 'image',
						src: src,
						thumb: src,
						sourceElement: scope
					});
				}

				scope.querySelectorAll && scope.querySelectorAll('product-image-zoom[data-image]').forEach((item) => {
					const src = item.getAttribute('data-image');
					addMedia({
						type: 'image',
						src: src,
						thumb: src,
						sourceElement: item
					});
				});

				scope.querySelectorAll && scope.querySelectorAll('video').forEach((video) => {
					const src = this._getVideoSrc(video);
					const poster = this._getVideoPoster(video);

					addMedia({
						type: 'video',
						src: src,
						thumb: poster,
						sourceElement: video
					});
				});

				scope.querySelectorAll && scope.querySelectorAll('model-viewer').forEach((model) => {
					const src =
						model.getAttribute('src') ||
						model.dataset.src ||
						model.getAttribute('data-src') ||
						'';

					const poster =
						model.getAttribute('poster') ||
						model.dataset.poster ||
						model.getAttribute('data-poster') ||
						'';

					addMedia({
						type: 'model',
						src: src,
						thumb: poster,
						sourceElement: model
					});
				});

				scope.querySelectorAll && scope.querySelectorAll('deferred-media template, template').forEach((template) => {

					if ( ! template.content ) return;

					const clonedTemplate = template.content.cloneNode(true);

					clonedTemplate.querySelectorAll('video').forEach((video) => {
						const src = this._getVideoSrc(video);
						const poster = this._getVideoPoster(video);

						addMedia({
							type: 'video',
							src: src,
							thumb: poster,
							sourceElement: video
						});
					});

					clonedTemplate.querySelectorAll('model-viewer').forEach((model) => {
						const src =
							model.getAttribute('src') ||
							model.dataset.src ||
							model.getAttribute('data-src') ||
							'';

						const poster =
							model.getAttribute('poster') ||
							model.dataset.poster ||
							model.getAttribute('data-poster') ||
							'';

						addMedia({
							type: 'model',
							src: src,
							thumb: poster,
							sourceElement: model
						});
					});

				});

			};

			/*
			Original collection approach commented:
			This collected all images first, then all videos, then all 3D objects.
			We commented it because that does not always match Shopify product media order.

			document.querySelectorAll('product-image-zoom[data-image]').forEach(...)
			document.querySelectorAll('video').forEach(...)
			document.querySelectorAll('model-viewer').forEach(...)
			*/

			/*
			Updated code:
			Looks for common Shopify product media containers and collects media from them in DOM order.
			This better matches Shopify product media order.
			*/
			const orderedMediaContainers = document.querySelectorAll(`
				[data-media-id],
				.product__media,
				.product-media,
				.product-gallery__media,
				.product-gallery-item,
				.product__media-item,
				.media-gallery__item,
				deferred-media,
				product-image-zoom
			`);

			if ( orderedMediaContainers.length ) {
				orderedMediaContainers.forEach((container) => {
					collectFromScope(container);
				});
			}

			if ( ! media.length ) {
				collectFromScope(document);
			}

			return media;

		}

		_findCurrentMediaIndex() {

			if ( ! this.zoomMediaItems || ! this.zoomMediaItems.length ) return 0;

			const clickedSrc = this.getAttribute('data-image');

			const index = this.zoomMediaItems.findIndex((item) => {
				return item.src === clickedSrc;
			});

			return index >= 0 ? index : 0;

		}

		_loadZoomMedia(index) {

			if ( ! this.zoomMediaItems || ! this.zoomMediaItems[index] ) return;

			this.zoom.classList.remove('loaded');

			this.currentZoomIndex = index;

			const media = this.zoomMediaItems[index];

			if ( this.stage ) {
				this.stage.innerHTML = '';
				this.stage.style.display = 'none';
				this.stage.style.background = '#E8ECF2';
				this.stage.style.transform = 'translate(-50%, -50%) scale(0.96)';
				this.stage.style.opacity = '0';
			}

			if ( this.image ) {
				this.image.style.transform = 'scale(0.96)';
				this.image.style.opacity = '0';
			}

			if ( media.type === 'image' ) {

				if ( this.stage ) {
					this.stage.style.display = 'none';
				}

				this.image.style.display = 'block';
				this.image.style.width = 'auto';
				this.image.style.height = 'auto';
				this.image.style.objectFit = 'contain';

				this.image.onload = () => {
					this._productZoomMount();
					this._animateZoomMedia();
				};

				this.image.src = media.src;

				if ( this.image.complete && this.image.naturalWidth > 0 ) {
					this._productZoomMount();
					this._animateZoomMedia();
				}

			}

			if ( media.type === 'video' ) {

				this.image.style.display = 'none';
				this.image.src = '';

				this.stage.style.display = 'flex';

				const video = document.createElement('video');

				video.src = media.src;
				video.autoplay = true;
				video.loop = true;
				video.muted = true;
				video.defaultMuted = true;
				video.playsInline = true;
				video.setAttribute('muted', '');
				video.setAttribute('playsinline', '');
				video.setAttribute('webkit-playsinline', '');

				/*
				Original video controls commented:
				We commented this because the video should autoplay silently on loop without visible controls.

				video.controls = true;
				*/

				/*
				Updated code:
				No controls shown.
				*/
				video.controls = false;
				video.removeAttribute('controls');

				if ( media.thumb ) {
					video.poster = media.thumb;
				}

				video.style.cssText = `
					max-width: 100%;
					max-height: 100%;
					width: auto;
					height: auto;
					object-fit: contain;
					display: block;
					background: #E8ECF2;
				`;

				this.stage.appendChild(video);

				video.load();

				const playPromise = video.play();
				if ( playPromise !== undefined ) {
					playPromise.catch(() => {});
				}

				this._productZoomMount();
				this._animateZoomMedia();

			}

			if ( media.type === 'model' ) {

				this.image.style.display = 'none';
				this.image.src = '';

				this.stage.style.display = 'flex';

				const model = media.sourceElement.cloneNode(true);

				model.style.cssText = `
					width: 100%;
					height: 100%;
					max-width: 100%;
					max-height: 100%;
					display: block;
					background: #E8ECF2;
				`;

				model.setAttribute('camera-controls', '');
				model.setAttribute('touch-action', 'pan-y');

				this.stage.appendChild(model);

				this._productZoomMount();
				this._animateZoomMedia();

			}

			this._updateActiveThumbnail();
			this._preloadAdjacentMedia();

		}

		_animateZoomMedia() {

			requestAnimationFrame(() => {
				if ( this.image && this.image.style.display !== 'none' ) {
					this.image.style.transform = 'scale(1)';
					this.image.style.opacity = '1';
				}

				if ( this.stage && this.stage.style.display !== 'none' ) {
					this.stage.style.transform = 'translate(-50%, -50%) scale(1)';
					this.stage.style.opacity = '1';
				}
			});

		}

		_preloadAdjacentMedia() {

			if ( ! this.zoomMediaItems || this.zoomMediaItems.length <= 1 ) return;

			const prevIndex = this.currentZoomIndex - 1 < 0 ? this.zoomMediaItems.length - 1 : this.currentZoomIndex - 1;
			const nextIndex = this.currentZoomIndex + 1 >= this.zoomMediaItems.length ? 0 : this.currentZoomIndex + 1;

			[this.zoomMediaItems[prevIndex], this.zoomMediaItems[nextIndex]].forEach((media) => {

				if ( ! media || ! media.src ) return;

				if ( media.type === 'image' ) {
					const img = new Image();
					img.src = media.src;
				}

				if ( media.type === 'video' ) {
					const video = document.createElement('video');
					video.src = media.src;
					video.muted = true;
					video.preload = 'metadata';
					video.load();
				}

			});

		}

		_changeZoomMedia(direction) {

			if ( ! this.zoomMediaItems || this.zoomMediaItems.length <= 1 ) return;

			this.currentZoomIndex += direction;

			if ( this.currentZoomIndex < 0 ) {
				this.currentZoomIndex = this.zoomMediaItems.length - 1;
			}

			if ( this.currentZoomIndex >= this.zoomMediaItems.length ) {
				this.currentZoomIndex = 0;
			}

			this._loadZoomMedia(this.currentZoomIndex);

		}

		_buildZoomThumbnails() {

			const thumbsWrapper = this.zoom.querySelector('.zoom__thumbs');

			if ( ! thumbsWrapper ) return;

			thumbsWrapper.innerHTML = '';
			thumbsWrapper.style.background = '#E8ECF2';

			this.zoomMediaItems.forEach((media, index) => {

				const thumb = document.createElement('button');
				thumb.type = 'button';
				thumb.className = 'zoom__thumb';
				thumb.setAttribute('data-index', index);

				thumb.style.cssText = `
					width: 58px;
					height: 58px;
					min-width: 58px;
					border-radius: 8px;
					border: 2px solid transparent;
					padding: 0;
					background: #E8ECF2;
					cursor: pointer;
					overflow: hidden;
					position: relative;
				`;

				if ( media.thumb ) {
					thumb.innerHTML = `
						<img src="${media.thumb}" style="
							width: 100%;
							height: 100%;
							object-fit: contain;
							object-position: center;
							display: block;
							background: #E8ECF2;
						" />
					`;
				} else {
					thumb.innerHTML = `
						<span style="
							width: 100%;
							height: 100%;
							display: flex;
							align-items: center;
							justify-content: center;
							font-size: 11px;
							font-weight: 700;
							color: #111;
							background: #E8ECF2;
						">${media.type === 'video' ? 'VIDEO' : '3D'}</span>
					`;
				}

				if ( media.type === 'video' ) {
					thumb.innerHTML += `
						<span style="
							position: absolute;
							left: 50%;
							top: 50%;
							transform: translate(-50%, -50%);
							width: 22px;
							height: 22px;
							border-radius: 50%;
							background: rgba(0,0,0,0.6);
							color: #fff;
							font-size: 12px;
							line-height: 22px;
							text-align: center;
						">▶</span>
					`;
				}

				if ( media.type === 'model' ) {
					thumb.innerHTML += `
						<span style="
							position: absolute;
							right: 3px;
							bottom: 3px;
							background: rgba(0,0,0,0.65);
							color: #fff;
							font-size: 10px;
							padding: 2px 4px;
							border-radius: 4px;
						">3D</span>
					`;
				}

				thumb.addEventListener('click', (e) => {
					e.stopPropagation();
					this._loadZoomMedia(index);
				});

				thumbsWrapper.appendChild(thumb);

			});

			this._updateActiveThumbnail();

		}

		/*
		Original active thumbnail scroll commented:
		This used scrollIntoView, but it only ensured the active thumbnail was visible.
		It did not properly center the active thumbnail inside the thumbnail strip.

		thumb.scrollIntoView({
			behavior: 'smooth',
			inline: 'center',
			block: 'nearest'
		});
		*/

		/*
		Updated code:
		Highlights the active thumbnail.
		Manually calculates the scroll position so the active thumbnail is centered in the strip.
		*/
		_updateActiveThumbnail() {

			const thumbsWrapper = this.zoom.querySelector('.zoom__thumbs');
			const thumbs = this.zoom.querySelectorAll('.zoom__thumb');

			thumbs.forEach((thumb, index) => {
				if ( index === this.currentZoomIndex ) {
					thumb.style.borderColor = '#1E4484';
					thumb.style.opacity = '1';

					if ( thumbsWrapper ) {
						const targetScrollLeft = thumb.offsetLeft - ( thumbsWrapper.clientWidth / 2 ) + ( thumb.clientWidth / 2 );

						thumbsWrapper.scrollTo({
							left: targetScrollLeft,
							behavior: 'smooth'
						});
					}

				} else {
					thumb.style.borderColor = 'transparent';
					thumb.style.opacity = '0.65';
				}
			});

		}

		_productZoomMount(image) {

			/*
			Original code commented:
			This reset the image position.
			We keep similar behavior for image stability, but without mouse-following.

			this.image.style.left = 0;
			this.image.style.top = 0;
			*/

			if ( this.image ) {
				this.image.style.left = 0;
				this.image.style.top = 0;
			}

			/*
			Original code commented:
			This made the image follow the cursor.
			We commented it because cursor movement was annoying.

			window.addEventListener('mousemove', this.onMouseMoveHandlerBinded, {passive:true});
			*/

			window.addEventListener('resize', this.onResizeHandlerBinded, {passive:true});
			this.onResizeHandler();

			setTimeout(()=>{
				this.zoom.classList.add('loaded');
			}, 50);

		}

		_productZoomUnmount() {

			this.zoom.classList.remove('opened');

			setTimeout(()=>{
				window.removeEventListener('resize', this.onResizeHandlerBinded);
				document.removeEventListener('keydown', this.onKeyDownHandlerBinded);
				this.zoom.removeEventListener('touchstart', this.onTouchStartHandlerBinded);
				this.zoom.removeEventListener('touchend', this.onTouchEndHandlerBinded);
				this.zoom.removeEventListener('mousedown', this.onMouseDownHandlerBinded);
				this.zoom.removeEventListener('mouseup', this.onMouseUpHandlerBinded);

				if ( this.image ) {
					this.image.src = '';
					this.image.className = 'zoom__main-image';
					this.image.style = '';
					this.image.style.transition = 'transform 0.28s ease, opacity 0.28s ease';
				}

				if ( this.stage ) {
					this.stage.innerHTML = '';
					this.stage.style.display = 'none';
					this.stage.style.transform = 'translate(-50%, -50%) scale(0.96)';
					this.stage.style.opacity = '0';
				}

				const thumbsWrapper = document.querySelector('#zoom .zoom__thumbs');
				if ( thumbsWrapper ) {
					thumbsWrapper.innerHTML = '';
				}

				this.zoom.classList.remove('loaded');
			}, 300);

		}

	}

	if ( typeof customElements.get('product-image-zoom') == 'undefined' ) {
		customElements.define('product-image-zoom', ProductImageZoom);
	}

}